import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../lib/axios";
import { API_PORTAL_URL } from "../../../lib/config";

export const getHomeDetails = createAsyncThunk(
  "Website/HomePageList",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Website/HomePageList`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Home:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllCMSByURL = createAsyncThunk(
  "CMS/FindByURLCMS",
  async (URL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/CMS/FindByURLCMS`,
        { CMSURL: URL },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Page Details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllMetaData = createAsyncThunk(
  "SeoTags/FindAllSeoTags",
  async (FormData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/SeoTags/FindAllSeoTags`,
        FormData,
      );
      return response.data?.Data ? response.data?.Data[0] : {};
    } catch (error: any) {
      console.error("Error Fetching Meta Data:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveSettings = createAsyncThunk(
  "Setting/FindAllActiveSetting",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Setting/FindAllActiveSetting`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Setting:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveBanner = createAsyncThunk(
  "Banner/FindAllActiveBanner",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Banner/FindAllActiveBanner`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Banner:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const insertInquiry = createAsyncThunk(
  "Inquiry/InsertInquiry",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Inquiry/InsertInquiry`,
        formdata,
      );
      // SuccessToast(response.data?.Data?.Details || "Success");
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error inserting inquiry:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveGallerys = createAsyncThunk(
  "Gallery/FindAllActiveGallery",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Gallery/FindAllActiveGallery`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Gallery images:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// ─── SERVER (native fetch — call ONLY from Server Components / page.tsx) ────

export async function fetchCMSData(URL: string) {
  try {
    const res = await fetch(`${API_PORTAL_URL}/CMS/FindByURLCMS`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ CMSURL: URL }),
      next: { revalidate: 1 },
    });
    const json = await res.json();
    return json.Data ?? [];
  } catch {
    return [];
  }
}
